import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private readonly _isProduction: Promise<boolean>;

  constructor(http: HttpClient) {
    this._isProduction = http.get('/api/environment').toPromise().then((resp: any) => resp.production)
  }

  public get isProduction() {
    return this._isProduction
  }

}
